module.exports = __webpack_public_path__ + "static/Polarsteps-98a0377437e88c8c2ca450b57127cf4e.png";